import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import { CaretSortIcon } from "@radix-ui/react-icons";
import { ArrowDown, ArrowUp } from "lucide-react";

export function DataTableColumnHeader({ column, title, className }) {
  if (!column.getCanSort()) {
    return (
      <div className={cn(
        "text-center px-2 py-1",
        "whitespace-normal break-words leading-tight",
        "text-xs sm:text-sm",
        className
      )}>
        {title}
      </div>
    );
  }

  const sortIcon = {
    desc: <ArrowDown className="ml-2 h-4 w-4 flex-shrink-0" />,
    asc: <ArrowUp className="ml-2 h-4 w-4 flex-shrink-0" />,
    default: <CaretSortIcon className="ml-2 h-4 w-4 flex-shrink-0" />,
  };

  return (
    <Button
      variant="ghost"
      onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
      className={cn(
        "h-auto min-h-0 flex items-center justify-center w-full space-x-2 hover:bg-transparent text-center px-2 py-1",
        "whitespace-normal break-words text-xs sm:text-sm",
        className
      )}
    >
      <span className="flex-1">{title}</span>
      {sortIcon[column.getIsSorted() || "default"]}
    </Button>
  );
}
